import {ROUTES} from '@/config/routesConstants';

/**
 * URL builders for creator profile pages.
 * Use these instead of hardcoding paths so routes stay in sync with ROUTES.
 */
const getCreatorProfilePageUrl = {
  default: (creatorId: string): string =>
    `${ROUTES.CREATOR_PROFILE}/${creatorId}`,

  fromCrm: (creatorId: string): string =>
    `${ROUTES.CREATOR_CRM}${ROUTES.CREATOR_PROFILE}/${creatorId}`,

  fromCrmOffPlatform: (creatorId: string): string =>
    `${ROUTES.CREATOR_CRM}/off-platform/${creatorId}`,

  fromCampaign: (campaignId: string, creatorId: string): string =>
    `${ROUTES.CAMPAIGNS_V2}/${campaignId}/creators${ROUTES.CREATOR_PROFILE}/${creatorId}`,

  fromCreatorsList: (creatorId: string): string =>
    `${ROUTES.MY_CREATORS}${ROUTES.CREATOR_PROFILE}/${creatorId}`,
};

export default getCreatorProfilePageUrl;
